import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { InfosUser } from '@classes/auth/infosUser';
import { ClientSmartHub, UserApp } from '@classes/client/client';
import { UserList } from '@classes/user/userlist';
import {
  faBell,
  faEdit,
  faEnvelope,
  faPlus,
  faSearch,
} from '@fortawesome/free-solid-svg-icons';
import { AuthService } from '@services/auth/auth.service';
import { OpenDialogEditUserComponent } from 'app/components/dialog/open-dialog-edit-user/open-dialog-edit-user.component';
import { OpendialogSendMailPasswordComponent } from 'app/components/dialog/opendialog-send-mail-password/opendialog-send-mail-password.component';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';
import { UserService } from '@services/user/user.service';
import { AddUsersComponent } from '../add-users/add-users.component';
import { NotifManagementComponent } from '../notif-management/notif-management.component';

@Component({
  selector: 'app-admin-users',
  templateUrl: './admin-users.component.html',
  styleUrls: ['./admin-users.component.scss'],
})
export class AdminUsersComponent implements OnInit {
  faPlus = faPlus;
  faSearch = faSearch;

  client: ClientSmartHub[];
  isActive = true;
  faEnvelop = faEnvelope;
  faPen = faEdit;
  faNotif = faBell;

  dataSource: MatTableDataSource<UserList>;
  displayedColumns: string[] = [
    'username',
    'client',
    'email',
    'Gsm',
    'application',
    'isActive',
    'password',
    'notif',
    'Edit',
  ];

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  route: any;
  data: any;
  send: boolean;
  dialogRef: any;
  users: UserList[];
  show = true;
  userConnected: InfosUser;

  constructor(
    public router: Router,
    private dialog: MatDialog,
    private authService: AuthService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.userConnected = this.authService.getDecodedToken();
    this.dataSource = new MatTableDataSource<UserList>(this.users);

    this.userService.clientChangedSubject.subscribe(() => {
      // this.isLoading = true;

      this.getListusers();
    });

    this.getListusers();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openDialogNotif(element: UserList): void {
    const dialogRef = this.dialog.open(NotifManagementComponent, {
      data: { element },
    });
  }

  openDialogAddUsers(): void {
    const dialogRef = this.dialog.open(AddUsersComponent, {
      width: '500px',
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getListusers();
    });
  }
  activeDesactive(isActive: boolean, id: string): void {
    if (isActive) {
      this.desactiveUser(isActive, id);
    } else {
      this.activeUser(isActive, id);
    }
  }

  private activeUser(isActive: boolean, id: string): void {
    this.userService.ActiveUser(id, isActive).subscribe({
      next: () => {
        this.send = true;
      },
    });
  }
  private desactiveUser(isActive: boolean, id: string): void {
    this.userService.DesactiveUser(id, isActive).subscribe({
      next: () => {
        this.send = true;
      },
    });
  }
  openDialogSendMailPassword(username: string): void {
    const dialogRef = this.dialog.open(OpendialogSendMailPasswordComponent, {
      data: {
        username,
      },
    });
  }

  openDialogEditUsers(element: UserList): void {
    const dialogRef = this.dialog.open(OpenDialogEditUserComponent, {
      width: '500px',
      data: { element },
    });

    dialogRef.afterClosed().subscribe((res) => {
      this.getListusers();
    });
  }

  private getListusers(): void {
    this.userService.getListusers().subscribe((res) => {
      this.users = res;

      this.dataSource = new MatTableDataSource<UserList>(this.users);
      this.dataSource.sort = this?.sort;
      this.dataSource.paginator = this.paginator;
    });
  }
}
